import $ from "jquery";
// import ua from "../libs/userAgent.js";
import "slick-carousel";

$(document).ready(function () {
  $(".biz-mv__ttl").slick({
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    fade: true,
    cssEase: "linear",
    arrows: false,
    dots: false,
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  $(".biz-merit__bg").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: "linear",
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    swipe: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    variableWidth: true,
  });

  $(".biz-facility__list").slick({
    // cssEase: "linear",
    infinite: false,
    arrows: false,
    dots: false,
    variableWidth: true,
  });

});
